import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycSpecialNeedsPlanningPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-special-needs-planning/']} />;
}
